import type { LoyaltyHubCard, LoyaltyHubContent } from '~/types/loyalty-hub';
import { getAssetsUrlForCDN } from '@/utils/template';

// Resolução das artes do hub "Club Fidelidade" e ordenação dos cards.
//
// Vive aqui — e não dentro dos componentes — porque o store precisa das MESMAS
// URLs que a UI vai pedir, pra aquecer as artes do topo antes da primeira
// abertura (ver `warmAssets` em stores/loyalty-hub.ts). Se as duas pontas
// derivassem o caminho por conta própria, o aquecimento silenciosamente puxaria
// um arquivo diferente do que o <img> renderiza.

const CARDS_BASE = '/assets/images/loyalty-hub/cards';
const DEFAULT_HEADER_DESKTOP = '/assets/images/loyalty-hub/header-desktop.webp';

// Fundo pré-composto do card (gradiente + arte + texto + CTA, com o bleed já
// embutido como transparência no topo). Mobile e desktop têm artes diferentes.
// O contrato pode sobrepor o MOBILE via `background`; o desktop segue sempre a
// convenção de caminho.
export function loyaltyHubCardArt(card: LoyaltyHubCard, desktop = false) {
  if (desktop) {
    return getAssetsUrlForCDN(`${CARDS_BASE}/desktop/${card.id}.webp`);
  }

  return getAssetsUrlForCDN(card.background ?? `${CARDS_BASE}/${card.id}.webp`);
}

// Header (imagem única: louros + "Seja bem-vindo a Clube Fidelidade" + hero).
// Devolve '' quando não há conteúdo — é o que o `v-if` do header observa.
export function loyaltyHubHeaderArt(
  content: LoyaltyHubContent | null | undefined,
  desktop = false,
) {
  if (!content) return '';

  if (desktop) {
    return getAssetsUrlForCDN(
      content.headerImageDesktop ?? DEFAULT_HEADER_DESKTOP,
    );
  }

  return content.headerImage ? getAssetsUrlForCDN(content.headerImage) : '';
}

// Ordem de exibição: `priority` menor primeiro, numa CÓPIA (a fonte continua
// intacta). Quem não tem `priority` cai pro fim, e o sort do JS é estável —
// então empate (inclusive entre os sem priority) preserva a ordem original.
// Cards desativados (`enabled: false`) NÃO são movidos nem removidos.
export function sortLoyaltyHubCards(
  cards: LoyaltyHubCard[] | undefined | null,
) {
  return [...(cards ?? [])].sort(
    (a, b) => (a.priority ?? Infinity) - (b.priority ?? Infinity),
  );
}
